// TODO(shawk): update this file with correct table fields to display for factors

/**
 * The file outlines the data necessary to construct the Comparison Table
 * View (/compare) which visualizes strategies compared against one another
 * in a large table format. The table enumerates all Strategy attributes
 * grouped into 3 sections: Expected Returns, Expected Risk, and Valuations.
 *
 * This information is structured in the following way: There is a list of
 * objects where each item contains the required information to build one
 * group of rows in the table. The object contains a `label` for the group
 * heading and a list of `attributes` that describe how to build the rows
 * within that group.
 *
 * An attribute definition is flexible enough to describe one of three
 * possible variations of a row's visual rendering. In the first variation,
 * a single value is displayed:
 *
 *   {
 *     type: 'single',
 *     attribute: 'Exp5YRTrackingError'
 *   }
 *
 * The above `attribute` definition says: "for this row, use the label and
 * value that correspond with `Exp5YRTrackingError`".
 *
 * Alternatively:
 *
 *   {
 *     type: 'split',
 *     labelAttribute: 'Exp5YRExGross',
 *     attributePrefix: 'Exp5YREx',
 *     attributeSuffixes: ['Net', 'Gross']
 *   }
 *
 * The above `attribute` definition says: "for this row, use the label that
 * corresponds with the `labelAttribute` and include 2 values within the row -
 * those 2 value fields are derived by concatenating each `suffix` onto the
 * `prefix`".
 *
 * Lastly:
 *
 *   {
 *     type: 'table',
 *     labelAttribute: 'Exp5YREx',
 *     headings: [
 *       '95th',
 *       '75th',
 *       '25th',
 *       '5th'
 *     ],
 *     attributes: [
 *       'Exp5YREx95th',
 *       'Exp5YREx75th',
 *       'Exp5YREx25th',
 *       'Exp5YREx5th'
 *     ]
 *   }
 *
 * The above `attribute` definition says: "for this row, render a nested table
 * with table headings that match `headings` and values that are produced by
 * looking up each `attributes` item in the Strategy."
 **/

export default [
  {
    label: 'Expected Returns (Ann.)',
    showInnerColumnHeadings: false,
    attributes: [
      {
        type: 'single',
        attribute: 'Exp5YRReturn'
      },
      {
        type: 'single',
        attribute: 'Exp5YRVol'
      },
      {
        type: 'single',
        attribute: 'Exp5YRSharpe'
      },
      {
        type: 'single',
        attribute: 'Exp5YRBeta'
      },
      {
        type: 'table',
        labelAttribute: 'Exp5YR95th', // TODO
        headings: [
          '95<sup>th</sup>',
          '75<sup>th</sup>',
          '50<sup>th</sup>',
          '25<sup>th</sup>',
          '5<sup>th</sup>'
        ],
        attributes: [
          'Exp5YR95th',
          'Exp5YR75th',
          'Exp5YRReturn',
          'Exp5YR25th',
          'Exp5YR5th'
        ]
      }
    ]
  },
  {
    label: 'Valuations (Long vs. Short)',
    showInnerColumnHeadings: false,
    attributes: [
      {
        type: 'single',
        attribute: 'CurrentRelValAgg'
      },
      {
        type: 'single',
        attribute: 'RelValAgg50th'
      },
      {
        type: 'single',
        attribute: 'CurrentRelValPB'
      },
      {
        type: 'single',
        attribute: 'RelValPB50th'
      }
    ]
  },
  {
    label: 'Historical (%{ITD}) (Ann.)',
    showInnerColumnHeadings: false,
    attributes: [
      {
        type: 'single',
        attribute: 'HistITDReturn'
      },
      {
        type: 'single',
        attribute: 'HistITDStructAlpha'
      },
      {
        type: 'single',
        attribute: 'HistITDRevalAlpha'
      },
      {
        type: 'single',
        attribute: 'HistITDVol'
      },
      {
        type: 'single',
        attribute: 'HistITDSharpe'
      },
      {
        type: 'single',
        attribute: 'HistITDBeta'
      }
    ]
  },
  {
    label: 'Historical (Recent 5 Years) (Ann.)',
    showInnerColumnHeadings: false,
    attributes: [
      {
        type: 'single',
        attribute: 'Hist5YRReturn'
      },
      {
        type: 'single',
        attribute: 'Hist5YRVol'
      },
      {
        type: 'single',
        attribute: 'Hist5YRSharpe'
      },
      {
        type: 'single',
        attribute: 'Hist5YRBeta'
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/components/factors/historical/comparison-groups.js